import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MainMenuLevel1ViewModel, MetaMenuLinkItemViewModel } from '@models/api.models';
import { SvgIconComponent } from '../../../../@shared/svg-icon/svg-icon.component';
import { LinkComponent } from '../../../../@shared/routing/link/link.component';
import { AutofocusDirective } from '../../../../@shared/autofocus/autofocus.directive';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-mobile-root-list',
    templateUrl: './mobile-root-list.component.html',
    styleUrls: ['./mobile-root-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, AutofocusDirective, NgFor, LinkComponent, SvgIconComponent]
})
export class MobileRootListComponent {
    @Input()
    public readonly menuGroups?: MainMenuLevel1ViewModel[];

    @Input()
    public readonly metaMenuItems?: MetaMenuLinkItemViewModel[] | null;

    @Output() setRootList = new EventEmitter<MainMenuLevel1ViewModel>();

    public setActiveRootList(RootList: MainMenuLevel1ViewModel): void {
        this.setRootList.next(RootList);
    }

    public trackById(index: number, element: MainMenuLevel1ViewModel): string {
        return element.id || index.toString();
    }
}
